var exports = {
  "k": "xaf9ae18d--6673e5--container",
};

module.exports = exports;
